import styled from 'styled-components';
import * as colors from '../../config/Colors/Ligth';

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const DrawerHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid ${colors.borderColor};
  background-color: #fafafa;

  > div {
    flex: 1;
  }

  h1 {
    font-size: 20px;
    margin: 0;
    margin-bottom: 5px;
    color: ${colors.titleFontColor};
  }

  p {
    font-size: 12px;
    color: ${colors.ligthFontColor};
    margin: 0;
  }

  @media (max-width: 768px) {
    padding: 12px 15px;

    h1 {
      font-size: 18px;
      margin-bottom: 3px;
    }

    p {
      font-size: 11px;
    }
  }
`;

export const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  background-color: #fafafa;
  position: relative;

  > div {
    margin-bottom: 0;
  }

  label {
    font-size: 12px;
    color: ${colors.labelFontColor};
    margin-bottom: 5px;
    display: block;
  }

  @media (max-width: 768px) {
    label {
      font-size: 11px;
      margin-bottom: 3px;
    }
  }
`;

export const DrawerFooter = styled.div`
  padding: 20px;
  border-top: 1px solid ${colors.borderColor};
  display: flex;
  justify-content: stretch;
  background-color: #fafafa;

  button {
    width: 100%;
    padding: 12px 24px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px 15px;

    button {
      padding: 10px 20px;
      font-size: 14px;
    }
  }
`;

export const SecaoFiltros = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 0;
  padding: 15px;
  padding-bottom: 10px;

  &:not(:last-of-type)::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${colors.borderColor};
    margin-top: 10px;
  }

  &:not(:last-of-type) {
    margin-bottom: 0;
  }

  > div {
    margin-bottom: 0;
    width: 100%;
  }

  /* Garantir que os inputs tenham fundo branco */
  .react-select__control,
  input,
  .MuiFormControl-root {
    background-color: #fff !important;
  }

  @media (max-width: 768px) {
    padding: 10px 12px;
    padding-bottom: 8px;
    gap: 6px;

    &:not(:last-of-type)::after {
      margin-top: 8px;
    }
  }
`;

export const SecaoTitulo = styled.h2`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.titleFontColor};
  margin: 0;
  margin-bottom: 6px;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 6px;
  }
`;

